import React from "react";
import { NumericFormat } from 'react-number-format';

const Input = ({ name, placeholder, dropdown , required, value, onValueChange, error, touched,onBlur }) => {

  const handleValueChange = (values) => {
    onValueChange(name, parseFloat(values.value));
  };

  return (
    <>
      <div className={`${ dropdown ? "py-4 bg-white border-t border-gray-300" : "" }`}>
        <NumericFormat
          id={name}
          name={name}
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-red-clarin focus:border-red-clarin sm:text-sm"
          placeholder={placeholder}
          thousandSeparator="."
          decimalSeparator=","
          allowNegative={false}
          value={value}
          onBlur={onBlur}
          onValueChange={handleValueChange}
          isnumericstring="true"
          required={required}
        />
      {error && touched ? (
        <div className="text-red-500 m-1">{error}</div>
      ) : null}
      </div>
    </>
  );
};

export default Input;
